import { useEffect } from 'react';
import { siteInfo, faqs } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function About() {
  useEffect(() => {
    document.title = '关于我们 - 17黑料网 | 品牌介绍与联系方式';
  }, []);

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: 'http://yiyaxiang.cn/',
    description: siteInfo.description,
    foundingDate: siteInfo.foundedYear,
    contactPoint: {
      '@type': 'ContactPoint',
      email: siteInfo.contact.email,
      contactType: 'customer service',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <main>
      <Navbar />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />

      <section className="relative w-full h-[320px] md:h-[400px] flex items-center justify-center overflow-hidden pt-16">
        <div className="absolute inset-0 top-16">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20elegant%20studio%20workspace%20with%20warm%20golden%20accent%20lighting%2C%20professional%20camera%20equipment%20silhouettes%2C%20luxurious%20dark%20atmosphere%2C%20editorial%20office%20vibe%2C%20cinematic%20moody%20lighting%2C%20abstract%20artistic%20composition%2C%20no%20people&width=1920&height=600&seq=about-hero&orientation=landscape"
            alt="关于17黑料网"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
        </div>
        <div className="relative z-10 text-center px-4">
          <h1 className="font-heading text-3xl md:text-5xl font-black text-white mb-3">
            关于我们
          </h1>
          <p className="font-heading text-base md:text-lg italic text-white/70 font-light">
            About 17黑料网
          </p>
        </div>
      </section>

      <section className="bg-background-50 py-4">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-12">
          <div className="mb-12">
            <span className="inline-block px-3 py-1 text-xs bg-primary-100 text-primary-700 rounded-full font-label mb-4">
              关于 17黑料网
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mb-6">
              品牌介绍
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-4">
              {siteInfo.description}
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4">
              自{siteInfo.foundedYear}年成立以来，17黑料网始终致力于为广大网民提供真实、全面、即时的网红黑料资讯。我们拥有一支专业的采编团队，每日追踪各大社交平台网红动态，第一时间报道塌房事件与争议话题。
            </p>
            <p className="text-foreground-700 leading-relaxed">
              我们坚持"理性吃瓜，不传谣不信谣"的原则，每篇报道都经过多方核实，力求为读者呈现最接近事实的事件全貌。同时，我们欢迎网友投稿爆料，共同维护一个健康、透明的网络环境。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-16">
            <div className="p-5 md:p-6 rounded-xl bg-background-100 text-center">
              <p className="text-2xl md:text-3xl font-bold text-foreground-900 font-label">
                {siteInfo.stats.operatingDays.toLocaleString()}+
              </p>
              <p className="text-xs text-foreground-500 mt-2">运营天数</p>
            </div>
            <div className="p-5 md:p-6 rounded-xl bg-background-100 text-center">
              <p className="text-2xl md:text-3xl font-bold text-foreground-900 font-label">
                {siteInfo.stats.totalArticles.toLocaleString()}+
              </p>
              <p className="text-xs text-foreground-500 mt-2">原创文章</p>
            </div>
            <div className="p-5 md:p-6 rounded-xl bg-background-100 text-center">
              <p className="text-2xl md:text-3xl font-bold text-foreground-900 font-label">
                {siteInfo.stats.dailyVisitors.toLocaleString()}+
              </p>
              <p className="text-xs text-foreground-500 mt-2">日均访客</p>
            </div>
            <div className="p-5 md:p-6 rounded-xl bg-background-100 text-center">
              <p className="text-2xl md:text-3xl font-bold text-foreground-900 font-label">
                {siteInfo.stats.accuracy}%
              </p>
              <p className="text-xs text-foreground-500 mt-2">爆料准确率</p>
            </div>
          </div>

          <div className="mb-16">
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mb-8">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="p-6 rounded-xl bg-background-50 border border-background-200">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">吃瓜达人</p>
                    <p className="text-xs text-foreground-400">忠实读者 · 3年</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  "全网吃瓜平台里最靠谱的一个，更新快、内容深、不标题党，忠实粉丝打卡三年了。"
                </p>
              </div>
              <div className="p-6 rounded-xl bg-background-50 border border-background-200">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-line text-accent-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">娱乐观察家</p>
                    <p className="text-xs text-foreground-400">行业从业者 · 2年</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  "作为同行，我对17黑料网的专业度非常认可。每篇文章都有理有据，信息来源标注清晰。"
                </p>
              </div>
              <div className="p-6 rounded-xl bg-background-50 border border-background-200">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-line text-green-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">理性吃瓜群众</p>
                    <p className="text-xs text-foreground-400">热心读者 · 1年</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  "最欣赏的是不偏激的态度，每次事件都会列出多方说法，让读者自己判断，这在吃瓜圈太难得了。"
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16">
            <div>
              <h2 className="font-heading text-2xl font-black text-foreground-950 mb-6">
                联系我们
              </h2>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 flex-shrink-0">
                    <i className="ri-mail-line text-foreground-600"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">投稿与合作</p>
                    <a href={`mailto:${siteInfo.contact.email}`} className="text-sm text-primary-600 hover:text-primary-700 transition-colors">
                      {siteInfo.contact.email}
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 flex-shrink-0">
                    <i className="ri-wechat-line text-foreground-600"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">微信公众号</p>
                    <p className="text-sm text-foreground-700">{siteInfo.contact.wechat}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 flex-shrink-0">
                    <i className="ri-weibo-line text-foreground-600"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">微博</p>
                    <p className="text-sm text-foreground-700">{siteInfo.contact.weibo}</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-black text-foreground-950 mb-6">
                侵权申诉
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                如果您认为本站内容侵犯了您的合法权益，请发送申诉材料至以下邮箱，我们将尽快核实处理。
              </p>
              <a
                href={`mailto:${siteInfo.contact.reportEmail}`}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 hover:bg-foreground-800 text-background-50 rounded-full font-label text-sm transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-mail-send-line"></i>
                提交申诉
              </a>
            </div>
          </div>

          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mb-8">
              常见问题
            </h2>
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <details key={index} className="group rounded-xl border border-background-200 bg-background-50">
                  <summary className="flex items-center justify-between p-5 cursor-pointer">
                    <span className="font-heading text-base font-semibold text-foreground-900">
                      {faq.question}
                    </span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}